export default __webpack_public_path__ + "static/media/icon_withdraw.09cda1b1.svg";